import PropTypes from 'prop-types'
import { Element } from '../../../../common/html/element'
import { ScrollComponent } from '../../../../common/scrollComponent'
import { CRITERIA_GROUP, OTHER_DATA } from '../constant'
import { GroupCriterira } from './GroupCriteria'
import classes from './index.module.scss'

export const CriteriaInfo = ({
  criteria,
  paddingContent,
  autoHeight,
  autoHeightMax,
}) => {
  return (
    <Element
      className={classes.selectedCriteria}
      style={{ backgroundColor: '#F3F3F3' }}
    >
      <ScrollComponent autoHeight={autoHeight} autoHeightMax={autoHeightMax}>
        <Element style={{ padding: paddingContent }}>
          {Object.keys(CRITERIA_GROUP).map((criteriaGroup) => (
            <GroupCriterira
              key={criteriaGroup}
              criteriaGroup={criteriaGroup}
              groupData={criteria[criteriaGroup]}
              currency={criteria[OTHER_DATA].currency}
            />
          ))}
        </Element>
      </ScrollComponent>
    </Element>
  )
}

CriteriaInfo.propTypes = {
  paddingContent: PropTypes.string,
  autoHeight: PropTypes.bool,
  autoHeightMax: PropTypes.number,
}

CriteriaInfo.defaultProps = {
  paddingContent: '8px 20px',
  autoHeight: false,
  autoHeightMax: 0,
}
